export default function sortAlphabetically(object, translator = value => value) {
  return Object.keys(object).sort((key1, key2) => (
    translator(key1).localeCompare(translator(key2))
  )).reduce((newObject, key) => {
    newObject[key] = object[key];
    return newObject;
  }, {});
}
